import { useExternalRowSelectionApi } from './useExternalRowSelectionApi';

export const useExternalRowSelectionCount = () => {
  const { selectedIds } = useExternalRowSelectionApi();

  const selectedRowsIds = Array.from(selectedIds) as string[];
  return selectedRowsIds.length;
};
